import React from "react";
import styles from './../Components/Pdl.module.css';

const Header = () => {
  return (
    <header className={`container-fluid border-bottom py-2 ${styles.header}`}>
      <div className="row align-items-center">
        
        {/* LEFT: LOGO */}
        <div className="col-3">
          <img
            src="/assets/img_Bus/driveAnalytics/tml-logo.png"
            alt="TML Logo"
            style={{ height: "30px" }}
          />
        </div>

        {/* CENTER: TITLE */}
        <div className="col-6 text-center">
          <h5 className="mb-0 fw-bold">Summary</h5>
        </div>

        {/* RIGHT: EMPTY (for spacing balance) */}
        <div className="col-3"></div>

      </div>
    </header>
  );
};

export default Header;
